import Model from '~/models/base/Model';

/**
 * class representing investigators
 * @extends Model
 * @author rn
 */
export default class Investigator extends Model {
    static _url = `${Model._url}/users`;
    static _legacyUrl = `${Model._legacyUrl}/save_incident.php`;

    constructor(id = null, options) {
        super(id, options);
    }

    static all(params) {
        const requestUrl = `${this._url}/investigators/`;
        const requestPayload = params || {};
        requestPayload.op_type = 'getAllInvestigators';
        return this.api.post(requestUrl, requestPayload);
    }

    // TODO: rewrite the endpoint in django
    /*
    static editRole(params = {}) {
        params.op_type = 'edit_investigator';
        /!*return this.legacyCall(params);*!/
        return this.api.patch(`${this._url}/investigators/`, params);
    }
    static editRole(params = {}) {
        params.op_type = 'edit_investigator';
        return this.legacyCall(params);
    }
    */
}
